<!--
  - Copyright (c) 2020. Minerva Networks.
  - All rights reserved.
  -->

<template>
  <div id="app" :class="`Page${$route.name}`" @mousemove="activateUser">
    <transition enterActiveClass="animated fadeIn" leaveActiveClass="animated fadeOut">
      <Modal v-if="modal.display" @close="closeModal" />
    </transition>
    <transition enterActiveClass="animated fadeIn" leaveActiveClass="animated fadeOut"
                mode="out-in">
      <Onboarding v-if="me.onboarding && !isWidget" />
    </transition>
    <transition enterActiveClass="animated fadeIn" leaveActiveClass="animated fadeOut"
                mode="out-in">
      <div v-if="loading" class="shadow">
        <fade-loader :loading="loading" :color="colors.mainActionColor" :height="'15px'"
                     :width="'6px'" />
      </div>
    </transition>
    <transition enterActiveClass="animated fadeIn" leaveActiveClass="animated fadeOut" mode="out-in">
      <div class="videoContainer" v-show="playerDisplay">
        <div class="playerWrapper" :style="page.playerStyle">
          <div class="controlsWrapper" :class="player.video_type">
            <Close class="exitFullscreen" />
              <div id="webcam" style="position:relative; display: none;">
                <div class="countdown"></div>
                <video id="player" class="webcamVideo" autoplay playsinline width="100%"></video>
                <canvas style="display: none" id="canvas" width="455" height="607"></canvas>
              </div>
            <template v-if="$route.name !== 'rds'">
              <transition
                enterActiveClass="animated fadeIn"
                leaveActiveClass="animated fadeOut"
              >
                <ReactionStripe
                  @activity="activateUser"
                  v-show="reactionBarVisible && ua"
                  :player="player"
                  :player-state="playerState"
                  :player-instance="playerInstance"
                />
              </transition>
            </template>
          </div>
          <video-player
            class="video-player-box videoInstance"
            ref="videoPlayer"
            :options="playerOptions"
            @ready="playerReadied($event)"
            @play="onPlayerPlay($event)"
            @ended="onPlayerEnded($event)"
            @pause="onPlayerPause($event)"
            @timeupdate="onTimeUpdate($event)"
            @error="$log.error($event)"
          >
          </video-player>
        </div>
      </div>
    </transition>
    <transition enterActiveClass="animated fadeIn" leaveActiveClass="animated fadeOut" mode="out-in">
      <me v-if="displayMe"></me>
    </transition>
    <transition :enterActiveClass="anim.in" :leaveActiveClass="anim.out" mode="out-in">
      <router-view />
    </transition>
    <footer v-if="false">
      <cookie-law theme="base" buttonText="OK">
        <div slot="message"> Here is my message for more info
          <router-link to="privacy">Click here</router-link>
        </div>
      </cookie-law>
    </footer>
  </div>
</template>

<script>
/* eslint-disable global-require,import/no-dynamic-require */
import FadeLoader from 'vue-spinner/src/FadeLoader.vue';
import { mapState, mapGetters, mapMutations } from 'vuex';
import MobileDetect from 'mobile-detect';
import throttle from 'lodash.throttle';
// import CookieLaw from 'vue-cookie-law';
// import Close from './components/glyphs/Close.vue';
// import me from './components/Me.vue';
// import Modal from './components/Modal.vue';
// import ReactionStripe from './components/ReactionStripe.vue';

// const FadeLoader = resolve => require(['vue-spinner/src/FadeLoader.vue'], resolve);
const CookieLaw = resolve => require(['vue-cookie-law'], resolve);
const ReactionStripe = resolve => require(['@/components/ReactionStripe.vue'], resolve);
const Close = resolve => require(['@/components/glyphs/Close.vue'], resolve);
const me = resolve => require(['@/components/Me.vue'], resolve);
const Modal = resolve => require(['@/components/Modal.vue'], resolve);
const Onboarding = resolve => require(['@/components/Onboarding'], resolve);

require('./assets/css/custom-theme.css');

export default {
  name: 'app',
  data() {
    return {
      ta: false,
      hls: null,
    };
  },
  components: {
    FadeLoader,
    Close,
    me,
    Onboarding,
    Modal,
    CookieLaw,
    ReactionStripe,
  },
  beforeMount() {
    const md = new MobileDetect(window.navigator.userAgent);
    this.setMd(md);
  },
  mounted() {
    window.ga('tok.send', 'event', 'Init');
    this.$nextTick(() => {
      this.refreshPageSizeInfo();
    });
    window.addEventListener('resize', throttle(() => {
      this.refreshPageSizeInfo();
    }, 250));
  },
  methods: {
    ...mapMutations([
      'setMd',
      'refreshPageSizeInfo',
      'playerReadied',
      'onPlayerPlay',
      'onPlayerEnded',
      'onPlayerPause',
      'playerStateChanged',
      'exitVideo',
      'setLoginInfo',
      'onTimeUpdate',
      'redirectToIP',
      'initModal',
      'toggleMute',
      'setShowPopover',
      'setUa',
    ]),
    activateUser() {
      this.setUa(true);
      /*
      clearTimeout(this.ta);
      const self = this;
      this.setUa(true);
      this.ta = setTimeout(() => {
        self.setUa(false);
        self.setShowPopover(false);
      }, 4000);
      */
    },
    isConcert(name) {
      return this.$store.state.singleV === this.$store.state.concertMap[name];
    },
    closeModal() {
      this.initModal({ display: false });
    },
  },
  computed: {
    ...mapGetters(['getPI']),
    ...mapState([
      'showReactionBar',
      'me',
      'namespace',
      'page',
      'loading',
      'player',
      'playerOptions',
      'playerDisplay',
      'playerState',
      'playerInstance',
      'loginInfo',
      'displayMe',
      'colors',
      'modal',
      'anim',
      'conf',
      'env',
      'ua',
    ]),
    reactionBarVisible() {
      return this.showReactionBar
        && this.me.registered === true
        && this.player.video_type === 'live'
        && !this.md.mobile();
    },
    isMuted() {
      return this.getPI.muted();
    },
    anyPanel() {
      return this.plays_on || this.players_on || this.highlights_on;
    },
    userActive() {
      if (this.playerInstance) {
        return this.playerInstance.userActive();
      }
      return false;
    },
  },
};
</script>
<style lang="scss">
body {
  margin: 0;
}

* {
  box-sizing: border-box;
}

@import url('https://fonts.googleapis.com/css?family=Roboto:400,500,800');
$bw: 100px;
$bos: $bw / 2;
.Landing__body__video {
  .video-js .vjs-big-play-button {
    display: unset;
    background-color: rgba(249, 142, 0, 0);
    border: 2px solid rgba(249, 142, 0, 1);
    cursor: pointer;
    height: $bw;
    width: $bw;
    line-height: $bw;
    top: calc(50% - #{$bos});
    left: calc(50% - #{$bos});
    border-radius: $bw;
    font-size: 30px;
  }
  .vjs-controls-disabled .vjs-big-play-button, .vjs-has-started .vjs-big-play-button, .vjs-using-native-controls .vjs-big-play-button, .vjs-error .vjs-big-play-button {
    display: none;
  }
 .vjs-big-play-button .vjs-icon-placeholder:before{
    font-size: 56px;
  }
}

.VueCarousel-dot-button:focus {
  outline: none !important;
}

.debug {
  padding: 20px;
  background-color: #fff;
  color: red;
  z-index: 2000;
}

.tlWm {
  position: absolute;
  top: 20px;
  left: 20px;
  width: 15%;
  max-width: 220px;
}

.trWm {
  position: absolute;
  top: 20px;
  right: 20px;
  display: flex;
  align-items: center;

  img {
    height: 16px;
  }
}
</style>
